import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AnnotationDefaults } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';

@Injectable({
  providedIn: 'root'
})
export class DrawDefaultsService {

  constructor(private http: HttpClient) { }

  getDrawDefaults(parameterName: string): Observable<cfgDrawParameter> {
    return this.http.get<cfgDrawParameter>(`api/drawParameters/getDrawParameters/${parameterName}`);
  }
  getAllDrawDefaults(): Observable<cfgDrawParameter[]> {
    return this.http.get<cfgDrawParameter[]>(`api/drawParameters/getAllDrawParameters/`);
  }

  saveDrawDefaults(userId: string, drawParameterObj: DrawParameterObj): Observable<cfgDrawParameter> {

    const payload = {
      drawParameterString: JSON.stringify(drawParameterObj),
    };
    const drawParameterString: string = JSON.stringify(drawParameterObj);
    return this.http.post<cfgDrawParameter>(`/api/drawParameters/saveDrawParameters/${userId}`, payload);

  }

}
